import React from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaCreditCard, FaCogs } from "react-icons/fa";
import "../HelpandSupport/HelpandSupport.css";

const HelpandSupport = () => {
  const navigate = useNavigate();

  return (
    <div className="helpcontainer">
      {/* Admin Support */}
      <div
        className="helpcard"
        onClick={() => navigate("/Sidebar/AdminSupport")}
      >
        <FaEnvelope size={24} color="#007BFF" />
        <span className="helpcard-text">Send Support Request to Admin</span>
      </div>

      {/* WhatsApp Support */}

      {/* Payment Dispute */}
      <div
        className="helpcard"
        onClick={() => navigate("/Sidebar/PaymentDispute")}
      >
        <FaCreditCard size={24} color="#FF5733" />
        <span className="helpcard-text">Raise a Payment Dispute</span>
      </div>

      {/* Technical Support */}
      <div
        className="helpcard"
        onClick={() => navigate("/Sidebar/TechSupport")}
      >
        <FaCogs size={24} color="#FFC107" />
        <span className="helpcard-text">Raise a Technical Support Request</span>
      </div>
    </div>
  );
};

export default HelpandSupport;
